import styled from 'styled-components';

export const HeaderBase = styled.div`
	padding-left: 12px;
	padding-right: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: transparent;
	padding-top: 8px;
	padding-bottom: 6px;
`;

export const HeaderLabel = styled.div`
	// layout
	display: flex;
	align-items: center;
	margin-bottom: 0px;
	margin-top: 0px;

	// style
	user-select: none;
	font-size: 17px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const HeaderActionsSection = styled.div`
	display: flex;
	gap: 0px;
	align-items: center;
	margin-top: 1px;
`;

// nested buttons are not allowed so we have a separate style for the dropdown trigger
export const DropdownTrigger = styled.div`
	background: transparent;
	border: none;
	border-radius: 6px;
	padding-left: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;
